import fetch from 'cross-fetch';
import { isMolfileNotEmpty } from './isMolfileNotEmpty';
export async function fetchPrediction(molfile, options) {
    if (!isMolfileNotEmpty(molfile)) {
        return {
            nucleus: '13C',
            joinedSignals: [],
            signals: [],
            ranges: [],
        };
    }
    const { webserviceURL } = options;
    const response = await fetch(webserviceURL, {
        headers: {
            accept: 'application/json',
            'content-type': 'application/json',
        },
        body: JSON.stringify({ molfile }),
        method: 'POST',
    });
    if (response.status >= 400) {
        throw new Error(response.statusText);
    }
    return (await response.json()).data;
}
//# sourceMappingURL=fetchPrediction.js.map